import { Drawer, Button } from '@mui/material';
import IcClose from '../../assets/image/ic_x.svg';
import IcCaution1 from '../../assets/image/ic_caution_1.svg';
import IcCaution2 from '../../assets/image/ic_caution_2.svg';
import IcCaution3 from '../../assets/image/ic_caution_3.svg';
import { useTranslation } from '../../hook/useTranslation';

function UploadVideoCautionDialog({ open, onClose = () => {}, onConfirm = () => {} }) {
  const { t } = useTranslation();
  return (
    <Drawer
      open={open}
      anchor="bottom"
      onClose={(event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason === 'backdropClick') return;
        if (onClose) (onClose as any)(event, reason);
      }}
      PaperProps={{ sx: { borderRadius: '10px 10px 0 0' } }}
    >
      <div className="w-full p-5 min-h-[200px] text-[#1C1C1C] font-['Pretendard'] flex flex-col items-center justify-between bg-white overflow-hidden">
        <div className="w-full flex justify-between items-center mb-3">
          <div className="w-[24px]" />
          <div className="w-full text-center text-[#1C1C1C] text-[18px] font-[600]">{t('upload.caution.title')}</div>
          <button
            type="button"
            onClick={onClose}
            className="w-[24px] h-[24px] flex items-center justify-center"
          >
            <img src={IcClose} alt="Close" />
          </button>
        </div>
        <div className="w-full flex justify-between items-start my-[30px] gap-2 px-2">
          <div className="flex flex-col items-center justify-start gap-1 w-1/3">
            <img src={IcCaution1} alt="Caution 1" className="w-[60px] h-[60px] mb-[12px]" />
            <div className="font-[700] text-[16px] text-center">{t('upload.caution.item1_title')}</div>
            <div className="text-[12px] font-[400] text-center text-[#767676] leading-[1.3] break-keep">
              {t('upload.caution.item1_desc').split('\n').map((line, i) => (
                <span key={i}>
                  {line}
                  {i === 0 && <br />}
                </span>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 w-1/3">
            <img src={IcCaution2} alt="Caution 2" className="w-[60px] h-[60px] mb-[12px]" />
            <div className="font-[700] text-[16px] text-center">{t('upload.caution.item2_title')}</div>
            <div className="text-[12px] font-[400] text-center text-[#767676] leading-[1.3] break-keep">
              {t('upload.caution.item2_desc').split('\n').map((line, i) => (
                <span key={i}>
                  {line}
                  {i === 0 && <br />}
                </span>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 w-1/3">
            <img src={IcCaution3} alt="Caution 3" className="w-[60px] h-[60px] mb-[12px]" />
            <div className="font-[700] text-[16px] text-center">{t('upload.caution.item3_title')}</div>
            <div className="text-[12px] font-[400] text-center text-[#767676] leading-[1.3] break-keep">
              {t('upload.caution.item3_desc').split('\n').map((line, i) => (
                <span key={i}>
                  {line}
                  {i === 0 && <br />}
                </span>
              ))}
            </div>
          </div>
        </div>
        <Button variant="contained" className="w-full" onClick={onConfirm}>
          {t('upload.caution.confirm_btn')}
        </Button>
      </div>
    </Drawer>
  );
}

export default UploadVideoCautionDialog;
